import React, { useState, createContext } from "react";

import light from '../styles/temas/light';
import dark from '../styles/temas/dark';

import usePersistedState from '../Context/hooks/usePersistedState';

const Context = createContext();

const TemaProvider = ({ children }) => {
    const [theme, setTheme] = usePersistedState('theme', light);

    function toggleTheme(){
        setTheme( theme.title == 'light' ? dark : light)
    }

    return(
        <Context.Provider value={{ theme , toggleTheme}}>
            {children} 
        </Context.Provider>
    );
}

export { Context, TemaProvider }; 